import { useMutation, useQuery, useQueryClient } from 'react-query';
import {GetAllActivePersonByTenantId,
    GetAllOKRStateByTenantId,
    GetAllScoreLevelsByTenantId,
    AddKeyResult,
    getMyObjectiveByTenantId,
    getMyMeetingByTenantId,
    getMyKeyResultByTenantId,
    AddObjective,
    getObjectiveDetailsById,
    getDashBoardDataByTenantId,
    getAllCooperateByPersonId,
    EditObjective,
    getAllObjectiveDefinitionLevelByTenantId,
    GetAllObjectiveOKRStateByTenantId,
    getObjectiveDetails,
    getKeyResultDetailsById,
    getAllObjectiveByPersonId,
    editKeyResult,
    editComment,
    deleteKr,
    getAllCommentById,
    getAllTeamAndPersonNameByTenantId,
    getAllKeyResultByTenantId,
    addComment,
    deleteComment
} from '../Api/index';
import { QueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { GetObjectiveAndKeyResultCountByPeriodId } from '../../Reports/Api';
// import { getAllBAUsByTeamId, getWebObjectiveDetailsCheckinMeetingByTeamId } from '../../Meeting/Api/Index';
// import { getAllBAU } from '../../IndexManaging/Api/Index';
//import { setOkrDeleteStateR } from '../OKRManageSlice/OKRManageSlice';

type option={
    id:string,
    name:string
}

// tenantId:any
const useGetAllActivePersonByTenantId=(tenantId:string|null)=>{
    return useQuery(['GetAllActivePersonByTenantId',tenantId],GetAllActivePersonByTenantId,{
        enabled:!!tenantId,
        cacheTime:Infinity,
        refetchOnWindowFocus:false,
   onSuccess:(data)=>{
//    console.log(data)
   }
   ,
   onError:(err:any)=>{
//    console.log(err)
   },
   select:(data:any)=>{
   let rawData=data?.data?.data;
   let tranFormed;
   if (rawData) {
    tranFormed=rawData.map(({name,id}:option)=>{
     return{key:name,value:id}
    })
   }
   
   return tranFormed
   }
    })
}

const useGetAllOKRStateByTenantId=(tenantId:string|null)=>{
    return useQuery(['GetAllOKRStateByTenantId',tenantId],GetAllOKRStateByTenantId,{
     enabled:!!tenantId,
     cacheTime:Infinity,
     refetchOnWindowFocus:false,
     onSuccess:(data:any)=>{
    //   console.log(data)
     }
     ,
     onError:(err:any)=>{
    //  console.log(err)
     },
     select:(data)=>{
   let rawData=data?.data?.data;
  let tranformed=rawData.filter((item:any)=>item.name!=='بسته شده').map(({id,name}:any)=>{
    return {label:name,id:id}
  })
  return tranformed
     }
    })
}
const useGetAllScoreLevelsByTenantId=(tenantId:string|null)=>{
return useQuery(['GetAllScoreLevelsByTenantId',tenantId],GetAllScoreLevelsByTenantId,{
    enabled:!!tenantId,
    refetchOnWindowFocus:false,
    cacheTime:Infinity,
    onSuccess:(data:any)=>{
    // console.log(data)
    },
    onError:(err:any)=>{
    //  console.log(err)
    }
    ,
    select:(data:any)=>{
    let rawData=data?.data?.data;
    // console.log(rawData);
    let levelids=rawData.map(({id,name}:any)=>{
        return {scoreLevelId:id,value:'',name}
    });
    return levelids
    // console.log(levelids)
    }

})
}


const useAddKeyResult=()=>{
    const queryClient=useQueryClient()
      return useMutation({
    mutationFn: (data:any) =>AddKeyResult(data),
    onSuccess: (data) => {
        queryClient.invalidateQueries('getObjectiveDetails')
    //   console.log(data)
    },
  });
}


const useGetMyKeyResultsByTenantId=(periodId:string | null,profileTenantId:string | null,personId:string | null)=>{
    // console.log(periodId)
  return useQuery(['GetMyKeyResultByTenantId',periodId,profileTenantId,personId],getMyKeyResultByTenantId,{
    enabled:!!periodId,
    // cacheTime:Infinity,
    refetchOnWindowFocus:false,
    onSuccess:(data:any)=>{
    // console.log(data)
    }
    ,onError:(err)=>{
    // console.log(err)
    } ,
    select:(data)=>{
    let rawData=data?.data?.data;
    return rawData
    }
  })
  }

const useEditKeyResult=(localEditKrSuccess:any)=>{
    const queryClient=useQueryClient()
      return useMutation({
    mutationFn: (data:any) =>editKeyResult(data),
    onSuccess: (data) => {
        queryClient.invalidateQueries('getObjectiveDetails');
        // queryClient.invalidateQueries("getMyKeyResultByTenantId");
        localEditKrSuccess()
    //   console.log(data)
    },
  });
}


const useGetMyObjectiveByTenantId=(periodId:string | null,profileTenantId:string | null)=>{
    // console.log(periodId)
return useQuery(['GetMyObjectiveByTenantId',periodId,profileTenantId],getMyObjectiveByTenantId,{
    enabled:!!periodId,
    // cacheTime:Infinity,
    refetchOnWindowFocus:false,
    onSuccess:(data:any)=>{
    // console.log(data)
    }
    ,onError:(err)=>{
    // console.log(err)
    } ,
    select:(data)=>{
    let rawData=data?.data?.data;
    return rawData
    }
})
}

const useGetDashBoardDataByyTenantId=(periodId:string | null,profileTenantId:string | null)=>{
    // console.log(periodId)
return useQuery(['GetMyDashBoardDataByTenantId',periodId,profileTenantId],getDashBoardDataByTenantId,{
    enabled:!!periodId,
    // cacheTime:Infinity,
    refetchOnWindowFocus:false,
    onSuccess:(data:any)=>{
    // console.log(data)
    }
    ,onError:(err)=>{
    // console.log(err)
    } ,
    select:(data)=>{
    let rawData=data?.data?.data;
    return rawData
    }
})
}

const useGetAllCooperateByPersonId=(periodId:string | null,profileTenantId:string | null)=>{
    // console.log(periodId)
return useQuery(['getAllCooperateByPersonId',periodId,profileTenantId],getAllCooperateByPersonId,{
    enabled:!!periodId,
    // cacheTime:Infinity,
    refetchOnWindowFocus:false,
    onSuccess:(data:any)=>{
    // console.log(data)
    }
    ,onError:(err)=>{
    // console.log(err)
    } ,
    select:(data)=>{
    let rawData=data?.data?.data;
    return rawData
    }
})
}

const useGetMyKeyResultByTenantId=(periodId:string | null,profileTenantId:string | null)=>{
    // console.log(periodId)
return useQuery(['GetMyKeyResultByTenantId',periodId,profileTenantId],getMyKeyResultByTenantId,{
    enabled:!!periodId,
    // cacheTime:Infinity,
    refetchOnWindowFocus:false,
    onSuccess:(data:any)=>{
    // console.log(data)
    }
    ,onError:(err)=>{
    // console.log(err)
    } ,
    select:(data)=>{
    let rawData=data?.data?.data;
    return rawData
    }
})
}

const useGetAllKeyResultByTenantId=(periodId:string | null,profileTenantId:string | null)=>{
    // console.log(periodId)
return useQuery(['GetAllKeyResultByTenantId',periodId,profileTenantId],getAllKeyResultByTenantId,{
    enabled:!!periodId,
    // cacheTime:Infinity,
    refetchOnWindowFocus:false,
    onSuccess:(data:any)=>{
    // console.log(data)
    }
    ,onError:(err)=>{
    // console.log(err)
    } ,
    select:(data)=>{
    let rawData=data?.data?.data;
    return rawData
    }
})
}

const useGetMyMeetingByTenantId=(periodId:string | null,profileTenantId:string | null)=>{
    // console.log(periodId)
return useQuery(['GetMyMeetingByTenantId',periodId,profileTenantId],getMyMeetingByTenantId,{
    enabled:!!periodId,
    // cacheTime:Infinity,
    refetchOnWindowFocus:false,
    onSuccess:(data:any)=>{
    // console.log(data)
    }
    ,onError:(err)=>{
    // console.log(err)
    } ,
    select:(data)=>{
    let rawData=data?.data?.data;
    return rawData
    }
})
}


const useGetAllObjectiveByPersonId=(periodId:string | null,profileTenantId:string | null)=>{
    // console.log(periodId)
return useQuery(['GetAllObjectiveByPersonId',periodId,profileTenantId],getAllObjectiveByPersonId,{
    enabled:!!periodId,
    // cacheTime:Infinity,
    refetchOnWindowFocus:false,
    onSuccess:(data:any)=>{
    // console.log(data)
    }
    ,onError:(err)=>{
    // console.log(err)
    } ,
    select:(data)=>{
    let rawData=data?.data?.data;
    return rawData
    }
})
}

const useAddObjective=()=>{
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data:any) =>AddObjective(data),
        onSuccess: (data) => {
            queryClient.invalidateQueries('GetAllObjectiveByPeriodId')
            queryClient.invalidateQueries('GetObjectiveAndKeyResultCountByPeriodId')
        },
        onError:(err)=>{
        console.log(err)
        }
      });
}

const useEditObjective=()=>{
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data:any) =>EditObjective(data),
        onSuccess: (data) => {
            queryClient.invalidateQueries('GetAllObjectiveByPeriodId')

        },
        onError:(err)=>{
        console.log(err)
        }
      });
}




 const useGetAllObjectiveDefinitionLevelByTenantId=(tenantId:string|null)=>{
   return useQuery(['getAllObjectiveDefinitionLevelByTenantId',tenantId],getAllObjectiveDefinitionLevelByTenantId,{
    enabled:!!tenantId,
    cacheTime:Infinity,
    refetchOnWindowFocus:false,
    onError:(err:any)=>{

    },
    select:(data:any)=>{
     let rawData=data?.data?.data;
    //  console.log(rawData)
     let transformed=rawData.map((item:any)=>{
        let {name:key,id:value,isCompany
        }=item
       return {key,value,isCompany}
     })
     return transformed
    }
   })
 }

const useGetAllObjectiveOKRStateByTenantId=(tenantId:string|null)=>{
    return useQuery(['GetAllOKRStateByTenantId',tenantId],GetAllOKRStateByTenantId,{
        enabled:!!tenantId,
        cacheTime:Infinity,
        refetchOnWindowFocus:false,
        onError:(err)=>{
        console.log(err)
        },
        select:(data)=>{
            let rawData=data?.data?.data;
            let transformed=rawData.map((item:any)=>{
            let{id,name}=item;
             return{id,label:name}
            }).filter((item:any)=>item.label!=="بسته شده")
            return transformed
      
        
        }
        
    })
}


const useGetObjectiveDetails=(objectiveId:string|null)=>{
return useQuery(['getObjectiveDetails',objectiveId],getObjectiveDetails,{
enabled:!!objectiveId,
refetchOnWindowFocus:false,
cacheTime:Infinity,
onSuccess:(data:any)=>{
//  console.log(data)
},
select:(data)=>{
 let rawData=data?.data?.data;
//  console.log(rawData)
 return rawData
}
})
}

const useGetKeyResultDetailsById=(krId:string|null)=>{
    return useQuery(['GetKeyResultDetailsById',krId],getKeyResultDetailsById,{
        enabled:!!krId,
        refetchOnWindowFocus:false,
        cacheTime:Infinity,
        onSuccess:(data:any)=>{
         console.log(data)
        },
        select:(data)=>{
         let rawData=data?.data?.data;
        //  console.log(rawData)
         return rawData
        }
        })
}


const useGetObjectiveDetailsById=(krId:string|null)=>{
    return useQuery(['GetObjectiveDetailsById',krId],getObjectiveDetailsById,{
        enabled:!!krId,
        refetchOnWindowFocus:false,
        cacheTime:Infinity,
        onSuccess:(data:any)=>{
         console.log(data)
        },
        select:(data)=>{
         let rawData=data?.data?.data;
        //  console.log(rawData)
         return rawData
        }
        })
}


const useGetAllTeamAndPersonNameByTenantId=(tenantId:any|string)=>{
    return useQuery(['GetAllTeamAndPersonNameByTenantId',tenantId],getAllTeamAndPersonNameByTenantId,{
        enabled:!!tenantId,
        refetchOnWindowFocus:false,
        cacheTime:Infinity,
        onSuccess:(data:any)=>{
        //  console.log(data)
        },
        select:(data)=>{
         let rawData=data?.data?.data;
         return rawData      
       
        }
        })
}

const useGetAllCommentById=(tenantId:any|string,meetingId:any)=>{
    return useQuery(['GetAllCommentById',tenantId,meetingId],getAllCommentById,{
        enabled:!!tenantId,
        refetchOnWindowFocus:false,
        cacheTime:Infinity,
        onSuccess:(data:any)=>{
        //  console.log(data)
        },
        select:(data)=>{
         let rawData=data?.data?.data;
         return rawData      
       
        }
        })
}

    const useAddComment = () => {
        const queryClient = useQueryClient();
        return useMutation({
        mutationFn: (data: any) => addComment(data),
        onSuccess: (data) => {
            queryClient.invalidateQueries('GetAllCommentById');           
            queryClient.invalidateQueries('getWebObjectiveDetailsCheckinMeetingByTeamId'); 
            queryClient.invalidateQueries('getAlignmentMeetingDetailByTeamId'); 
            queryClient.invalidateQueries('getAllBAUsByTeamId'); 
            queryClient.invalidateQueries('getAllBAU'); 
            queryClient.invalidateQueries("GetMyKeyResultByTenantId");
            queryClient.invalidateQueries("GetMyObjectiveByTenantId");
        },
        });
    };

    const useEditComment = () => {
        const queryClient = useQueryClient();
        return useMutation({
        mutationFn: (data: any) => editComment(data),
        onSuccess: (data) => {
            queryClient.invalidateQueries('GetAllCommentById');
        },
        });
    };

    const useDeleteComment = () => {
        const queryClient = useQueryClient();
        return useMutation({
        mutationFn: (data: any) => deleteComment(data),
        onSuccess: (data) => {
            queryClient.invalidateQueries('GetAllCommentById');           
            queryClient.invalidateQueries('getWebObjectiveDetailsCheckinMeetingByTeamId'); 
            queryClient.invalidateQueries('getAlignmentMeetingDetailByTeamId'); 
            queryClient.invalidateQueries('getAllBAUsByTeamId'); 
            queryClient.invalidateQueries('getAllBAU'); 
        },
        });
    };



export{
    useGetAllActivePersonByTenantId,
    useGetAllCooperateByPersonId,
    useGetAllOKRStateByTenantId,
    useGetAllScoreLevelsByTenantId,
    useAddKeyResult,
    useGetMyMeetingByTenantId,
    useGetMyKeyResultByTenantId,
    useGetMyObjectiveByTenantId,
    useGetAllObjectiveByPersonId,
    useAddObjective,
    useGetAllObjectiveDefinitionLevelByTenantId,
    useGetAllObjectiveOKRStateByTenantId,
    useGetObjectiveDetails,
    useGetKeyResultDetailsById,
    useGetDashBoardDataByyTenantId,
    useEditKeyResult,
    useEditObjective,
    useGetObjectiveDetailsById,
    useGetAllKeyResultByTenantId,
    // useDeleteObject,
    useAddComment,
    useEditComment,
    useDeleteComment,
    useGetAllCommentById,
    useGetAllTeamAndPersonNameByTenantId
}